export function buildDirectoryPath(): string {
  return '/directory';
}

export function buildListingPath(citySlug?: string, therapySlug?: string): string {
  const city = (citySlug ?? 'all').trim().toLowerCase() || 'all';
  const therapy = (therapySlug ?? 'all').trim().toLowerCase() || 'all';

  if ((city === 'all' || city === 'therapies') && therapy === 'all') {
    return buildDirectoryPath();
  }

  return `/${city}/${therapy}`;
}

export function buildBestHubPath(): string {
  return '/best';
}

export function buildBestPagePath(slug: string): string {
  return `/best/${slug}`;
}

export function buildBlogHubPath(): string {
  return '/journal';
}

export function buildBlogPagePath(slug: string): string {
  return `/journal/${slug}`;
}

export function buildProgrammaticPagePath(slug: string): string {
  return `/discover/${slug}`;
}

export function buildOutboundVenuePath(
  venueSlug: string,
  destinationType: 'website' | 'booking',
  sourcePath?: string,
): string {
  const params = new URLSearchParams({ type: destinationType });
  if (sourcePath) params.set('from', sourcePath);
  return `/out/${encodeURIComponent(venueSlug)}?${params.toString()}`;
}
